import { useEffect, useRef } from "react";

const TELEGRAM_URL = "https://t.me/Vertttess";

export default function HeroSection() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-fade-in-up");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    const elements = sectionRef.current?.querySelectorAll(".reveal");
    elements?.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="hero"
      ref={sectionRef}
      className="relative min-h-[100dvh] flex items-center justify-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="/readdy/85ea0022e15c770e97a722ec848914ba.jpg"
          alt="Элегантный интерьер отеля"
          className="w-full h-full object-cover"
        />
        {/* Dark overlay for text contrast */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-5xl mx-auto px-4 md:px-8 text-center py-24">
        {/* Logo */}
        <div className="reveal opacity-0 mb-8">
          <img
            src="/readdy/6606b04b1f7f2f98f392e21c6ab06083.png"
            alt="Have Received"
            className="h-24 md:h-32 w-auto mx-auto drop-shadow-lg"
          />
        </div>

        {/* Title */}
        <h1 className="reveal opacity-0 font-heading text-4xl md:text-6xl lg:text-7xl text-white mb-6 leading-tight drop-shadow-lg">
          Have Received
        </h1>

        {/* Description */}
        <p className="reveal opacity-0 font-body text-lg md:text-xl text-white/90 max-w-3xl mx-auto mb-4 leading-relaxed drop-shadow">
          Профессиональный подбор и обучение администраторов для гостиничных
          комплексов
        </p>
        <p className="reveal opacity-0 font-body text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-10 leading-relaxed drop-shadow">
          Отели, гостиницы, пансионаты, хостелы и санатории — находим для вас
          тех, кто создаёт первое впечатление и оставляет незабываемый след
        </p>

        {/* CTA Button */}
        <div className="reveal opacity-0">
          <a
            href={TELEGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 px-8 py-4 text-base md:text-lg font-medium bg-primary-500 text-white rounded-lg hover:bg-primary-600 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap"
          >
            <i className="ri-telegram-line text-xl" />
            Связаться с нами
          </a>
        </div>
      </div>
    </section>
  );
}